(function($) {
    $.fn.newModal = function(action, options = null) {

        const self = this; 

        if ( options?.preventOverlayClosing === true ) {
            self.data('prevent-overlay-closing', true);
        }

        function open() {
            self.fadeIn(300);
            $('html,body').addClass('new-modal-fixed');
        }

        function close() {
            self.fadeOut(300);
            self.removeData(); // clears all data attributes. f
            $('html,body').removeClass('new-modal-fixed');
        }

        this.on('click', function(event) {
            if (!self.data('prevent-overlay-closing')) {
                close();
            }
        }); 

        this.find('.new-modal-content').on('click', function(event) {
            event.stopPropagation();
        })

        if ( action == 'open' ) {
            open();
        }

        if ( action == 'close') {
            close();
        }

        return this; 
    }
}(jQuery));

window.showroom = {
    showroomUpdated: false, 
    isShowroomOpen: !!(window.location.pathname == '/account' && ~window.location.search.indexOf('showroom=open')),
    isAccountPageOpen: window.location.pathname == '/account',
    isShowroomOwner: false,
    invitedShowroomId: null,
    invitedShowroomPrefix: '#showroom-page-',
    getShowroomUrl(showroomId) {
        return showroomId
            ? `/account${this.invitedShowroomPrefix}${showroomId}`
            : '/account?showroom=open';
    },
    openShowroomPage(showroomId) {
        if (window.showroom.isShowroomOpen) {
            if (window.showroom.selectors.showroomPage.text().trim().length == 0) {
                window.location.reload();
                return true
            }

            return false;
        }
        
        window.location = window.showroom.getShowroomUrl(showroomId);

        // Forces a reload since we only changed the hash
        if (showroomId && window.showroom.isAccountPageOpen) {
            window.location.reload();
        }
        
        return true;
    },
    generateInitialsFromMember(member) {
        return [
            (member.first_name || '').split('').shift(),
            (member.last_name || '').split('').shift(),
        ].join('');
    },
    generateFullNameFromMember(member) {
        return [
            member.first_name || '',
            member.last_name || '',
        ].join(' ').trim();
    },
    triggerShowroomCreationModal() {
        if (!this.room.room_id || this.room.room_id.toLowerCase() === 'false') {
            this.selectors.showroomModal.plainModal('open');
        } else {
            window.location = this.getShowroomUrl();
        }
    },
    selectors: {
        loadCommentsBtn: "[data-load-comments]",
        loginShowroomBtn: "[data-showroom-login]",
        createShowroomBtn: "[data-showroom-create]",
        openShowroomBtn: "[data-showroom-open]",
        editShowroomBtn: "[data-showroom-edit]",
        addToShowroomBtn: "[data-showroom-add]",
        showroomModal: "#new-showroom-modal",
        editShowroomModal: "#edit-showroom-modal",
        showroomInviteModal: "#new-showroom-modal-2",
        showroomConfirmModal: "#new-showroom-modal-3",
        showroomInvitationModal: "#new-showroom-modal-4",
        addInviteEmailBtn: "[data-add-invite-email]",
        showroomForm: "#new-showroom-form",
        editShowroomForm: "#edit-showroom-form",
        inviteForm: "#invite-emails-form",
        gotoShowroomBtn: "[data-showroom-goto-btn]",

        showroomFbLink: "[data-showroom-fb-link]",
        showroomLinkInput: "[data-showroom-link]",
        showroomLinkCopy: "[data-showroom-link-copy]",

        invitationInitials: "[data-invitation-initials]",
        invitationFirstName: "[data-invitation-first-name]",
        invitationDismiss: "[data-invitation-dismiss]",
        invitationJoin: "[data-invitation-join]",

        bridesmaidRemoveLink: '[data-delete-member]',

        // showroom page selectors
        showroomPage: "#showroom-page",
        accountPage: "#showroom-account-page",
        showroomInviteBridesmaidBtn: "[data-showroom-invite-button]",
        assignProductBtn: "[data-showroom-product-assign]",

        openMembershipShowroom: "[data-showroom-membership-open]",

        commentPostBtn: "[data-comment-post]",
        commentInput: "[data-comment-box]",
        voteBtn: "[data-showroom-product-vote]",

        removeFromShowroomBtn: "[data-showroom-remove-product]",

        closeModalBtn: "[data-trigger-modal-close]",

        // Showroom-related meta tags
        metaShowroomRoomId: 'meta[name="kb:showroom-room-id"]',
        metaShowroomCustomerId: 'meta[name="kb:customer-id"]',
        metaShowroomCustomerEmail: 'meta[name="kb:customer-email"]',
    },
    room: {
        room_id: false,
        customer_id: false,
        data: {},
        members: {}
    },
    host: "https://showroom.kennedyblue.com",
    urls: {
        createShowroom: "/api/showroom/create",
        updateShowroom: "/api/showroom/update",
        addToShowroom: "/api/showroom/add",
        removeFromShowroom: "/api/showroom/remove",
        removeFromShowroomById: "/api/showroom/removeById",
        sendInvites: "/api/showroom/update/invites",
        processShowroomInvite: "/api/showroom/processInvite",
        getInvitationData: "/api/showroom/getInvitation",

        addCustomer: "/api/customers/add",
        
        dressAssign: "/api/dress/assign",
        changeDressVariant: "/api/dress/change/variant",
        dressVote: "/api/dress/vote",

        commentPost: "/api/comment/create",
        commentRemove: "/api/comment/delete",
        loadComments: "/api/comment/index",

        removeShowroomMember: '/api/showroom/removeBridesmaid',
    },
    helpers: {
        getFormData: function ($form) {
            var unindexed_array = $form.serializeArray();
            var indexed_array = {};

            $.map(unindexed_array, function (n, i) {
                indexed_array[n['name']] = n['value'];
            });

            return indexed_array;
        },
        getCurrentVariantId: function (btn = false) {
            const fromUrl = window.location.href.split('?variant=')[1];
            if (fromUrl) {
                return fromUrl;
            } else {
                const fromSelect = $("#product-select").val();

                if (fromSelect) {
                    return fromSelect;
                } else {
                    if (btn) {
                        return btn.attr('data-showroom-variant');
                    } else {
                        return false;
                    }
                }
            }
        }
    },
    cacheSelectors: function () {
        const _t = this;
        
        if (_t.selectorStrings) _t.selectors = {..._t.selectorStrings};
        _t.selectorStrings = {};

        Object.keys(_t.selectors).forEach(function (key) {
            _t.selectorStrings[key] = _t.selectors[key];
            _t.selectors[key] = $(_t.selectors[key]);
        });
        Object.keys(_t.urls).forEach(function (key) {
            if (!_t.urls[key].startsWith(_t.host))
                _t.urls[key] = `${_t.host}${_t.urls[key]}`;
        });

        _t.openShowroom = _t.openShowroom.bind(this);
    },


    // load comments 
    loadComments: function (id) {
        const _t = this,
            selectors = _t.selectors;

        if ($(".showroom-product").length < 1) {
            return;
        }

        $.ajax({
            method: "GET",
            url: _t.urls.loadComments,
            data: {
                showroom_id: id
            },
            success: function (res) {
                for (let data of res.comments) {
                    let p_id = data.id;

                    let container = $(`[data-showroom-comments-container=${p_id}]`);
                    container.find('[data-comment]').remove();

                    for (let comment of data.comments) {
                        $(`<div class="showroom-commment-box" data-comment="${comment.id}">
                        <div class="comment-profile">
                            ${comment.initials}
                        </div>
                        <div class="comment-info">
                            <div class="comment-text">
                                <div class="comment-author">${comment.author}</div>
                                ${comment.text}</div>
                            ${parseInt(comment.customer_id) == _t.room.customer_id ? `<a href="javascript:void(0);" data-comment-remove class="comment-box-icon">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 4L4 12" stroke="#828282" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4 4L12 12" stroke="#828282" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>`: ""}
                        </div>
                    </div>`).appendTo(container);
                    }
                }
            }
        })
    },

    // showroom functions 
    createShowroom: function (data) {
        const _t = this,
            selectors = _t.selectors;

        _t.selectors.createShowroomBtn.find('span').text('Creating Showroom...');

        $.ajax({
            url: _t.urls.createShowroom,
            method: "POST",
            data: {
                customer_id: _t.room.customer_id,
                showroom: data
            },
            success: function (res) {
                _t.room.room_id = res.showroom.id;
                _t.room.data = res;
                window.showroom.showroomUpdated = true; 
                _t.selectors.showroomModal.plainModal('close');

                const link = `${window.location.origin}#showroom-${res.showroom.link+'-'+btoa(_t.room.customer_email)}`;
                const fbLink = `https://www.facebook.com/sharer/sharer.php?u=${link}`;
                selectors.showroomFbLink.attr('href', fbLink);
                selectors.showroomLinkInput.val(link);
                setTimeout(function () {
                    _t.selectors.showroomInviteModal.newModal('open', {preventOverlayClosing: true});
                }, 1000);
                // _t.selectors.showroomInviteModal.plainModal('open');
            }
        })

    },
    updateShowroom: function(data) {
        const _t = this,
            selectors = _t.selectors;

        $.ajax({
            url: _t.urls.updateShowroom,
            method: "POST",
            data: {
                room_id: _t.room.room_id,
                showroom: data
            },
            success: function (res) {
                // v8.0.4: Reset the submit-button text immediately on success.
                // Previously only the error handler reset it, so a successful
                // save left the button with the "Saving..." label persisted
                // on the live DOM node. Re-opening the edit modal then showed
                // a stuck "SAVING..." button — looked broken even when the
                // save itself worked. Reset before close so it's correct
                // regardless of what the close handler does.
                $('#edit-showroom-form button[type=submit]').text('Update');

                _t.room.room_id = res.showroom.id;
                window.showroom.showroomUpdated = true;
                _t.selectors.editShowroomModal.plainModal('close');

                // v7.11: Replaced location.reload() with in-place UI update.
                // The reload was both slow (full page re-fetch + asset reload)
                // AND caused the confirm modal to flash during the new page's
                // render-before-init window. Patching the visible values
                // directly is instant and stays on the same page.
                try {
                    _t.room.data = res.showroom;
                    var saved = res.showroom || {};
                    var $sidebar = $('.showroom-info');
                    if ($sidebar.length) {
                        if (saved.name) $sidebar.find('.showroom-info-header h3').text(saved.name);
                        var $rows = $sidebar.find('.showroom-info-list table tr');
                        // Rows order in template: Wedding Date, Roles, Budget, Colors, Coordination
                        if (saved.wedding_date) {
                            // Format yyyy-mm-dd or m/d/yyyy → "Month DD, YYYY"
                            var d = new Date(saved.wedding_date);
                            if (!isNaN(d)) {
                                var formatted = d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
                                $rows.eq(0).find('td').text(formatted);
                            }
                        }
                        if (saved.roles) $rows.eq(1).find('td').text(saved.roles);
                        if (saved.budget) $rows.eq(2).find('td').text(saved.budget);
                        if (saved.colors) $rows.eq(3).find('td').text(saved.colors);
                        if (saved.mixmatch) $rows.eq(4).find('td').text(saved.mixmatch);
                    }
                } catch (e) {
                    // If anything in the in-place update fails, fall back to
                    // a reload so the user still sees the latest data.
                    console.warn('[showroom] in-place update failed, reloading', e);
                    location.reload();
                }
            },
            error: function () {
                // Re-enable the form button on error so user can retry.
                $('#edit-showroom-form button[type=submit]').text('Update');
                alert('Could not save your changes. Please try again.');
            }
        })

    },
    sendInvites: function (data) {
        const _t = this;

        // v8.9.18.0: accept either legacy array-of-emails OR new array-of-{email,role}
        const invitees = (Array.isArray(data) && data.length && typeof data[0] === 'object')
            ? data.filter(function(i){ return i && i.email; })
            : data.filter(function(e){ return e; }).map(function(e){ return { email: e, role: 'Bridesmaid' }; });

        const brideName = (window.showroom_data && window.showroom_data.customer_name) || '';
        const brideFirstName = (window.showroom_data && window.showroom_data.customer_first_name) || '';
        const brideId = _t.room.customer_id;
        const partyCode = _t.room.room_id;
        let weddingDate = '';
        try {
            const rd = window.showroom_data && window.showroom_data.room_data
                ? (typeof window.showroom_data.room_data === 'string'
                    ? JSON.parse(window.showroom_data.room_data)
                    : window.showroom_data.room_data)
                : null;
            weddingDate = (rd && rd.showroom && rd.showroom.wedding_date) || '';
        } catch (e) {}

        Promise.all(
            [
                fetch(_t.urls.sendInvites, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        emails: invitees.map(function(i){ return i.email; }),
                        customer_id: brideId,
                        showroom_id: partyCode,
                    }),
                }),
                // v8.9.18.0: per-invitee — update Klaviyo profile (persistent properties for segmentation)
                // AND fire the existing Invite Bridesmaids event (backward compat with existing flows)
                ...invitees.flatMap(function (invitee) {
                    const linkBase = $("#showroom-link-input").val() || '';
                    const klProps = {
                        kb_bride_customer_id: brideId,
                        kb_bride_name: brideName,
                        kb_wedding_party_code: partyCode,
                        kb_wedding_date: weddingDate,
                        kb_role: invitee.role,
                        kb_is_wedding_party_member: true,
                    };
                    return [
                        makeKlaviyoApiRequest('client/profiles', makeKlaviyoRequestData('profile', {}, {
                            email: invitee.email,
                            properties: klProps,
                        })),
                        makeKlaviyoApiRequest('client/events', makeKlaviyoRequestData('event', {}, {
                            profile: makeKlaviyoRequestData('profile', {}, { email: invitee.email }),
                            metric: makeKlaviyoRequestData('metric', {}, { name: 'Invite Bridesmaids' }),
                            properties: {
                                showroom_link: linkBase + '-' + btoa(invitee.email),
                                owner: brideFirstName,
                                bride_customer_id: brideId,
                                wedding_party_code: partyCode,
                                wedding_date: weddingDate,
                                role: invitee.role,
                            }
                        }))
                    ];
                })
            ]
        ).then(() => {
            $('#invite-emails-form').find('[type=submit]').text('Send Invite')
            _t.selectors.showroomInviteModal.newModal('close');
            setTimeout(function () {
                _t.selectors.showroomConfirmModal.plainModal('open');
            }, 1000); 
        }).catch(err => console.error('Failed sending invitations:', err))
        

        /*$.ajax({
            url: _t.urls.sendInvites,
            method: "POST",
            data: {
                customer_id: _t.room.customer_id,
                showroom_id: _t.room.room_id,
                emails: data
            },
            success: function (res) {
                 _t.selectors.showroomInviteModal.newModal('close);
                 $('#invite-emails-form').find('[type=submit]').text('Send Invite')
                setTimeout(function () {
                    _t.selectors.showroomConfirmModal.plainModal('open');
                }, 1000);
             }
        })*/
    },
    openShowroom: function () {
        const selectors = this.selectors;
        selectors.openShowroomBtn.closest('li').addClass('active').siblings('li').removeClass('active');
        selectors.accountPage.hide();
        selectors.showroomPage.show();
        
        // Handles empty showroom => show creation flow
        if (selectors.showroomPage.children().length == 0) {
            this.triggerShowroomCreationModal();
        }
        
        // v8.9.18.4: poll comments every 5s (was 1s) to keep bride's view fresh
        // without hammering the API. The "using too many resources" warning on
        // invitation accept seemed tied to aggressive polling combined with
        // other background JS during the auth flow.
        const _t = this;
        const interval_id = `scomments_${_t.room.room_id}`;
        _t.loadComments(_t.room.room_id);
        if (!window[interval_id]) {
            window[interval_id] = setInterval(function () {
                _t.loadComments(_t.room.room_id);
            }, 5000);
        }
    },
    addToShowroom: function (id, handle, variant_id) {
        const _t = this;
        return new Promise((res, rej) => {
            $.ajax({
                url: _t.urls.addToShowroom,
                method: "POST",
                data: {
                    product_id: id,
                    showroom_id: _t.room.room_id,
                    product_handle: handle,
                    variant_id: variant_id
                },
                success: function (data) {
                    if (data && data.product_ids && data.product_ids != '') {
                        $(".showroom-empty-wrapper").hide();
                        $(".showroom-full-wrapper").show();
                    }
                    // v8.9.18.7: show a small toast confirming which showroom got the save.
                    // Clears the confusion for members who have multiple showrooms — saves
                    // always go to YOUR OWN showroom, not to one you've been invited to.
                    try {
                        var roomName = '';
                        try {
                            var rd = window.showroom_data && window.showroom_data.room_data
                                ? (typeof window.showroom_data.room_data === 'string'
                                    ? JSON.parse(window.showroom_data.room_data)
                                    : window.showroom_data.room_data)
                                : null;
                            roomName = (rd && rd.showroom && rd.showroom.name) || '';
                        } catch(e) {}
                        var msg = roomName ? 'Saved to ' + roomName : 'Saved to your showroom';
                        if (typeof _t.showToast === 'function') {
                            _t.showToast(msg);
                        } else if (typeof window.showToast === 'function') {
                            window.showToast(msg);
                        }
                    } catch (e) {}
                    res(data);
                }
            })
        });
    },
    removeFromShowroom: function (id, variant_id) {
        const _t = this;
        return new Promise((res, rej) => {
            $.ajax({
                url: _t.urls.removeFromShowroom,
                method: "POST",
                data: {
                    product_id: id,
                    showroom_id: _t.room.room_id,
                    variant_id: variant_id
                },
                success: function (data) {
                    if( data.product_ids == '') {
                        $(".showroom-full-wrapper").hide();
                        $(".showroom-empty-wrapper").show();
                    }
                    res(data);
                }
            })
        });
    },
    removeFromShowroomById: function (id) {
        const _t = this;
        return new Promise((res, rej) => {
            $.ajax({
                url: _t.urls.removeFromShowroomById,
                method: "POST",
                data: {
                    id,
                    showroom_id: _t.room.room_id
                },
                success: function (data) {
                    if( data.product_ids == '') {
                        $(".showroom-full-wrapper").hide();
                        $(".showroom-empty-wrapper").show();
                    }
                    res(data);
                }
            })
        });
    },

    setModalEvents: function () {
        const _t = this,
            selectors = _t.selectors;

        new ClipboardJS('.btn-clipboard-copy ');
        const inviteModal = selectors.showroomInviteModal;

        $(".skip-btn").on("click", function(){
            inviteModal.newModal('close');
            window.showroom.openShowroomPage();
        })

        inviteModal.find('[data-tab]').on('click', function () {
            if ($(this).hasClass('active')) {
                return;
            }

            const id = $(this).attr('data-tab');
            const tab = inviteModal.find(`[data-tab-content='${id}']`);
            tab.siblings().hide();
            tab.show();

            $(this).siblings().removeClass('active');
            $(this).addClass('active');
        });

        selectors.invitationJoin.on('click', function (e) {
            e.preventDefault();
            const btn = $(this);
            btn.text("Joining....");
            if(_t.room.customer_id){
                _t.processShowroomInvites().then(data => {
                    selectors.showroomInvitationModal.plainModal("close");
                    sessionStorage.removeItem("showroom_invite_pending");
                    window.showroom.openShowroomPage(sessionStorage.getItem("showroom_invite_room_id"));
                });
            } else {
                localStorage.setItem('after-registration', window.location.href);
                window.location.href="/account/register";
            }
        });
        selectors.invitationDismiss.on('click', function () {
            selectors.showroomInvitationModal.plainModal('close');
            sessionStorage.removeItem('showroom_invite_pending');
        });

    },
    // v8.9.19.7: re-usable X-button decorator. Adds an unassign × button
    // to every [data-bridesmaid-assigned] pill that doesn't already have one.
    // Safe to call multiple times — idempotent.
    decorateUnassignButtons: function () {
        const _t = this;
        const members = (_t.room && _t.room.members) || [];
        $('[data-bridesmaid-assigned]').each(function () {
            const $el = $(this);
            if ($el.find('[data-bridesmaid-unassign]').length > 0) return;
            const bridesmaidId = $el.attr('data-bridesmaid-assigned');
            if (!bridesmaidId) return;
            const member = members.find(function (m) { return m.id == bridesmaidId; });
            const fullName = member ? _t.generateFullNameFromMember(member) : '';
            $el.attr('title', fullName).addClass('kb-bridesmaid-assigned');
            $el.append('<button type="button" class="kb-bridesmaid-unassign" data-bridesmaid-unassign="' + bridesmaidId + '" aria-label="Remove ' + fullName + '">\u00d7</button>');
        });
    },

    // v8.9.19.7: MutationObserver on .showroom-products grids. Re-decorates
    // assigned pills with X buttons whenever the chunked render replaces
    // cards (which used to strip the X). Debounced 150ms to avoid thrash.
    installUnassignObserver: function () {
        const _t = this;
        if (window.__kbUnassignObserverInstalled) return;
        window.__kbUnassignObserverInstalled = true;
        const grids = document.querySelectorAll('.showroom-products');
        grids.forEach(function (grid) {
            let debounce = null;
            const obs = new MutationObserver(function () {
                clearTimeout(debounce);
                debounce = setTimeout(function () {
                    try { _t.decorateUnassignButtons(); } catch (e) {}
                }, 150);
            });
            obs.observe(grid, { childList: true, subtree: true });
        });
    },

    setMembershipEvents: function () {
        const _t = this,
            selectors = _t.selectors;

        selectors.openMembershipShowroom.on('click', function (e) {
            //e.preventDefault();
            const id = $(this).attr('data-showroom-membership-open');
            $("#showroom-page").hide().siblings().hide();
            $(`#showroom-page-${id}`).show();

            // v8.9.19.7: fix blank-on-click. preload() only fires loadProducts
            // when the URL hash contains #showroom-page-<id> at page load.
            // If the member arrived at /account directly and clicked a
            // membership tile, products never loaded. Force the fetch now
            // if the grid for this membership is empty.
            try {
                const $page = $(`#showroom-page-${id}`);
                const $grid = $page.find('.showroom-products');
                if ($grid.length && $grid.children().length === 0) {
                    _t.invitedShowroomId = id;
                    _t.loadProducts().then(function () {
                        try { _t.decorateUnassignButtons(); } catch (e) {}
                    });
                }
            } catch (err) { console.warn('[showroom] blank-on-click fix failed', err); }

            const interval_id = `scomments_${id}`;
            _t.loadComments(id);
            if (!window[interval_id]) {
                // v8.9.18.6: dial 1s -> 5s on membership comment polling too
                window[interval_id] = setInterval(function () {
                    _t.loadComments(id);
                }, 5000);
            } else {
                clearInterval(window[interval_id]);
                window[interval_id] = false;
            }
        });
    },
    setEvents: function () {
        const _t = this,
            selectors = _t.selectors;

        const validateRequiredFields = function (formData, requiredFields) {
            return (requiredFields || []).filter((field) => !(formData[field] && formData[field].length > 0));
        };

        $('#wedding_date').datepicker({
            minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)
        });
        let wedDate = new Date($('#edit_wedding_date').val().replace("00:00:00", ""));
        let month = wedDate.getMonth().toString();
        let wedDateStr = `${month}/${wedDate.getDate()}/${wedDate.getFullYear()}`;
        $('#edit_wedding_date').datepicker({
            minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1),
            value: wedDateStr
        });

        $("[data-create-showroom-trigger]").on('click', function () {
            selectors.showroomModal.plainModal('open');
        })

        // v8.9.20.5: Initializes modals. DO NOT call plainModal on showroomInviteModal —
        // it conflicts with newModal('open') which is what actually opens that modal.
        // plainModal sets centering CSS (top:50% left:50% transform:translate(-50%,-50%) with
        // inline width/height = 50% viewport) on the .new-modal overlay, leaving it as a
        // tiny centered box instead of a full-screen backdrop. That's the "gray bars" bug.
        // showroomInviteModal is opened via newModal — let its CSS class .new-modal handle
        // full-viewport positioning unaided.
        if (selectors.showroomModal && selectors.showroomModal.plainModal)
            selectors.showroomModal.plainModal();
        if (selectors.showroomConfirmModal && selectors.showroomConfirmModal.plainModal)
            selectors.showroomConfirmModal.plainModal();

        selectors.showroomInviteBridesmaidBtn.on('click', function () {
            const link = `${window.location.origin}#showroom-${_t.room.data.link}`;
            const fbLink = `https://www.facebook.com/sharer/sharer.php?u=${link}`;
            selectors.showroomFbLink.attr('href', fbLink);
            selectors.showroomLinkInput.val(link);
            selectors.showroomInviteModal.newModal('open');
        });
        selectors.gotoShowroomBtn.on('click', function (e) {
            e.preventDefault();
            _t.selectors.showroomConfirmModal.plainModal("close");
            window.showroom.openShowroomPage();
        });
        selectors.createShowroomBtn.on('click', function (e) {
            e.preventDefault();
            if (!_t.room.room_id) {
                _t.triggerShowroomCreationModal();
            }
            else {
                localStorage.setItem('after-registration', $(this).attr('href'));
                location.href = $(this).attr('href');
            }

        });

        selectors.editShowroomBtn.on('click', function (e) {
            e.preventDefault();
            if (_t.room.room_id) {
                selectors.editShowroomModal.plainModal('open');
            }
            else {
                window.showroom.openShowroomPage();
            }

        });
        selectors.showroomForm.on('submit', function (e) {
            e.preventDefault();
            const data = _t.helpers.getFormData($(this));
            const btn = $(this).find('button[type=submit]');
            
            const requiredFields = {
                'wedding_date': 'Please include your wedding date!',
                'roles': 'Please select a role!',
                'budget': 'Please select a valid budget!',
                'colors': 'Please select a color option!',
                'mixmatch': 'Please select a coordination style!',
            };

            const missingFields = validateRequiredFields(data, Object.keys(requiredFields));

            if (missingFields.length > 0) {
                alert(missingFields.map(field => requiredFields[field]).join('\n'));
                return;
            }

            btn.text('Saving...');

            _t.createShowroom(data);
        });

        selectors.editShowroomForm.on('submit', function (e) {
            e.preventDefault();
            const data = _t.helpers.getFormData($(this));
            const btn = $(this).find('button[type=submit]');
            
            const requiredFields = {
                'name': 'Please name your showroom!',
                'wedding_date': 'Please include your wedding date!',
                'roles': 'Please select a role!',
                'budget': 'Please select a valid budget!',
                'colors': 'Please select a color option!',
                'mixmatch': 'Please select a coordination style!',
            };

            const missingFields = validateRequiredFields(data, Object.keys(requiredFields));

            if (missingFields.length > 0) {
                alert(missingFields.map(field => requiredFields[field]).join('\n'));
                return;
            }

            btn.text('Saving...');

            _t.updateShowroom(data);
        });

        selectors.inviteForm.on('submit', function (e) {
            e.preventDefault();
            const $form = $(this);
            const btn = $form.find('[type=submit]');
            // v8.9.18.0: gather parallel arrays of emails + roles
            const emails = $form.find('input[name="emails[]"]').map(function(){ return (this.value || '').trim(); }).get();
            const roles  = $form.find('select[name="roles[]"]').map(function(){ return this.value || 'Bridesmaid'; }).get();
            const invitees = [];
            emails.forEach(function(email, i){
                if (email) invitees.push({ email: email, role: roles[i] || 'Bridesmaid' });
            });
            if (invitees.length === 0) {
                btn.text('Send Invite');
                return;
            }
            btn.text('Sending...');
            _t.sendInvites(invitees);
        })

        selectors.addInviteEmailBtn.on('click', function (e) {
            e.preventDefault();
            // v8.9.18.0: include role select on dynamically-added rows
            const row = `<div class="form-group form-group--invitee"><input type="email" name="emails[]" placeholder="Email address"><select name="roles[]" class="kb-invite-role"><option value="Bridesmaid">Bridesmaid</option><option value="Maid of Honor">Maid of Honor</option><option value="Mother of the Bride">Mother of the Bride</option><option value="Mother of the Groom">Mother of the Groom</option><option value="Father of the Bride">Father of the Bride</option><option value="Father of the Groom">Father of the Groom</option><option value="Groom">Groom</option><option value="Groomsman">Groomsman</option><option value="Other">Other</option></select></div>`;
            $(row).insertBefore($("[data-attach-email]"));
        });
        selectors.showroomLinkCopy.on('click', function () {
            setTimeout(function () {
                // Action when the Copy Link button has been clicked
                // selectors.showroomInviteModal.newModal('close);
                // setTimeout(function () {
                //     selectors.showroomConfirmModal.plainModal('open');
                // }, 1000)
            }, 1500);
        });
        selectors.showroomFbLink.on('click', function () {
            setTimeout(function () {
                // Action when the Facebook button has been clicked
                // selectors.showroomInviteModal.newModal('close);
                // setTimeout(function () {
                //     selectors.showroomConfirmModal.plainModal('open');
                // }, 1000)
            }, 1500);
        });

        selectors.openShowroomBtn.on('click', function (e) {
            // e.preventDefault();
            // _t.openShowroom();
            // const interval_id = `scomments_${_t.room.room_id}`;
            // _t.loadComments(_t.room.room_id);
            // if (!window[interval_id]) {
            //     window[interval_id] = setInterval(function () {
            //         _t.loadComments(_t.room.room_id);
            //     }, 1000);
            // } else {
            //     clearInterval(window[interval_id]);
            //     window[interval_id] = false;
            // }

        });
        const pop = $(`
            <div class='showroom-popover'>
                <a href="javascript:void(0)" data-v="" data-add-product-to-showroom></a>
            </div>
        `).appendTo($("body"));

        // v7.11 fix: delegated binding so heart/add-to-showroom works on
        // collection cards rendered AFTER cacheSelectors() (Boost SD client-side
        // renders, infinite-scroll appends, etc.). Same delegation pattern used
        // for the trash button in v7.10.
        // v7.17: hanger icon click immediately performs the add/remove action,
        // no popover middleman. Old version showed a popover ("Add to {name}")
        // that the user had to click again — two clicks for one intent. Now
        // it's one tap on the hanger → API call → toast notification fires.
        $(document).off('click.kbShowroomAdd').on('click.kbShowroomAdd', '[data-showroom-add]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $btn = $(this);
            if ($btn.data('showroom-processing')) return;

            var productId = $btn.data('showroom-add');
            var handle = $btn.data('showroom-handle');
            var variantId = _t.helpers.getCurrentVariantId($btn) || $btn.attr('data-showroom-variant');
            var roomData = (_t.room && _t.room.data) || {};
            var roomName = roomData.name || 'Showroom';
            var isAdded = $btn.attr('data-showroom-added') !== undefined &&
                          $btn.attr('data-showroom-added') !== null;
            // Also defensive: check if the variant is in the live state list
            var variants = ((window.showroom_data && window.showroom_data.variants) || '').toString().split(',').filter(Boolean);
            if (!isAdded && variantId && variants.indexOf(variantId.toString()) > -1) {
                isAdded = true;
            }

            $btn.data('showroom-processing', true);
            $btn.addClass('kb-showroom-hanger--processing');

            if (isAdded) {
                _t.removeFromShowroom(productId, variantId).then(function (data) {
                    if (data) {
                        if (data.product_ids != null) window.showroom_data.products = data.product_ids;
                        if (data.variant_ids != null) window.showroom_data.variants = data.variant_ids;
                        _t.persistShowroomState(data);
                    }
                    $btn.removeAttr('data-showroom-added');
                    $btn.removeClass('kb-showroom-hanger--processing');
                    $btn.data('showroom-processing', false);
                    if (typeof _t.syncShowroomCardStates === 'function') {
                        try { _t.syncShowroomCardStates(); } catch (e) {}
                    }
                    _t.showToast('Removed from ' + roomName);
                }).catch(function () {
                    $btn.removeClass('kb-showroom-hanger--processing');
                    $btn.data('showroom-processing', false);
                });
            } else {
                _t.addToShowroom(productId, handle, variantId).then(function (data) {
                    if (data) {
                        if (data.product_ids != null) window.showroom_data.products = data.product_ids;
                        if (data.variant_ids != null) window.showroom_data.variants = data.variant_ids;
                        _t.persistShowroomState(data);
                    }
                    $btn.attr('data-showroom-added', 'true');
                    $btn.removeClass('kb-showroom-hanger--processing');
                    $btn.data('showroom-processing', false);
                    if (typeof _t.syncShowroomCardStates === 'function') {
                        try { _t.syncShowroomCardStates(); } catch (e) {}
                    }
                    _t.showToast('Added to ' + roomName);
                }).catch(function () {
                    $btn.removeClass('kb-showroom-hanger--processing');
                    $btn.data('showroom-processing', false);
                });
            }
        });

        $(document).on('click', '[data-add-product-to-showroom]', function () {

            const th = $(this),
                v = th.attr('data-v'),
                btn = $(`[data-showroom-variant="${v}"]`);

            const id = btn.data('showroom-add'),
                handle = btn.data('showroom-handle');

            this.classList.add('showroom-link-processing');
            let variant_id = _t.helpers.getCurrentVariantId(btn);
            if (showroom_data.variants.indexOf(variant_id) > -1) {
                _t.removeFromShowroom(id, variant_id).then((data) => {
                    window.showroom_data.variants = data.variant_ids;
                    window.showroom_data.products = data.product_ids;
                    window.showroom.persistShowroomState(data);
                    btn.removeAttr('data-showroom-added');
                    pop.find(`[data-v=${variant_id}]`).html(`
                    <svg class="kb-hanger-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="6.5" r="1.5"/><path d="M12 8 V11 L3 17 H21 L12 11"/></svg> Add to Showroom
                    `);
                    this.classList.remove('showroom-link-processing');
                });
            } else {
                _t.addToShowroom(id, handle, variant_id).then((data) => {
                    window.showroom_data.variants = data.variant_ids;
                    window.showroom_data.products = data.product_ids;
                    window.showroom.persistShowroomState(data);
                    btn.attr('data-showroom-added', true);
                    pop.find(`[data-v=${variant_id}]`).html(`
                    <svg class="kb-hanger-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="6.5" r="1.5"/><path d="M12 8 V11 L3 17 H21 L12 11"/></svg>
                    Remove from Showroom
                    `);
                    this.classList.remove('showroom-link-processing');
                })
            }
        });

        $(document).on('click', '[data-showroom-add-2]', function () {

            const btn = $(this);

            const id = btn.data('showroom-add-2'),
                handle = btn.data('showroom-handle');

            const btn2 = $(`[data-showroom-add=${id}]`);

            this.classList.add('showroom-link-processing');
            let variant_id = _t.helpers.getCurrentVariantId(btn);
            if (showroom_data.variants.indexOf(variant_id) > -1) {
                _t.removeFromShowroom(id, variant_id).then((data) => {
                    window.showroom_data.variants = data.variant_ids;
                    window.showroom_data.products = data.product_ids;
                    window.showroom.persistShowroomState(data);
                    btn.removeAttr('data-showroom-added');
                    btn2.removeAttr('data-showroom-added');
                    pop.find(`[data-v=${variant_id}]`).html(`
                    <svg class="kb-hanger-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="6.5" r="1.5"/><path d="M12 8 V11 L3 17 H21 L12 11"/></svg> Add to Showroom
                    `);
                    btn.html(`
                    <svg class="kb-hanger-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="6.5" r="1.5"/><path d="M12 8 V11 L3 17 H21 L12 11"/></svg> Add to Showroom
                    `);
                    this.classList.remove('showroom-link-processing');
                });
            } else {
                _t.addToShowroom(id, handle, variant_id).then((data) => {
                    window.showroom_data.variants = data.variant_ids;
                    window.showroom_data.products = data.product_ids;
                    window.showroom.persistShowroomState(data);
                    btn.attr('data-showroom-added', true);
                    btn2.attr('data-showroom-added', true);
                    pop.find(`[data-v=${variant_id}]`).html(`
                    <svg class="kb-hanger-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="6.5" r="1.5"/><path d="M12 8 V11 L3 17 H21 L12 11"/></svg>
                    Remove from Showroom
                    `);
                    btn.html(`
                    <svg class="kb-hanger-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="6.5" r="1.5"/><path d="M12 8 V11 L3 17 H21 L12 11"/></svg>
                    Remove from Showroom
                    `);
                    this.classList.remove('showroom-link-processing');
                })
            }
        });

        // v7.10 fix: delegated binding so clicks work on dress-planner items
        // that are rendered AFTER cacheSelectors() ran. Showroom product cards
        // are injected by template strings later in this file (see lines ~716,
        // 738, 779), and the prior `selectors.removeFromShowroomBtn.on(...)`
        // form only attached handlers to elements present at bind time — so
        // the trash icon never fired on those dynamically-rendered cards.
        // $(document).on('click', selector, fn) catches every matching element,
        // including those added later. Logic inside the handler is unchanged.
        // .off() guards against double-binding if init runs more than once.
        $(document).off('click.kbShowroomRemove').on('click.kbShowroomRemove', '[data-showroom-remove-product]', function (e) {
            e.preventDefault();
            const $t = $(this);
            if ($t.attr('data-showroom-removing') != undefined) {
                return;
            }
            $t.attr('data-showroom-removing', true);
            const id = $t.attr('data-showroom-remove-product');
            _t.removeFromShowroomById(id).then((data) => {
                window.showroom_data.variants = data.variant_ids;
                window.showroom_data.products = data.product_ids;
                window.showroom.persistShowroomState(data);
                $t.removeAttr('data-showroom-adding');
                const product = $t.closest('.showroom-product');
                product.fadeOut(function () {
                    product.remove();
                })
            })
        })

        $('body').on('click', (e) => {
            if (!e.target.closest('.product-assign-wrap')) {
                $('.assign-list.open').hide().removeClass('open');
            }
        });

        // v7.11 fix: delegated binding — assign-to-bridesmaid button is inside
        // dynamically-rendered showroom-product cards, so direct .on() never
        // attached a handler. Same fix pattern as the trash button.
        $(document).off('click.kbShowroomAssign').on('click.kbShowroomAssign', '[data-showroom-product-assign]', function () {
            const list = $(this).next('[data-showroom-bridesmaids-list]');

            if (list.hasClass('open')) {
                list.hide().removeClass('open');
                return;
            }
            const bridesmaids = $(this).closest(".showroom-product").data('bridesmaids');
            let toBe = [];
            for (let m of _t.room.members) {
                if (bridesmaids.indexOf(m.id + "") < 0) {
                    toBe.push(m);
                }
            }
            $(".assign-list").hide();

            list.empty();
            for (let m of toBe) {
                console.log(m);
                $(`<a href="javascript:void(0)" data-assign-bridesmaid="${m.id}"><span class="bridesmaid-icon">${_t.generateInitialsFromMember(m)}</span> ${_t.generateFullNameFromMember(m)}</a>`).appendTo(list);
            }
            list.show().addClass('open');
        });


        // v7.11 fix: delegated binding — comment box and post button are
        // inside dynamically-rendered showroom-product cards.
        $(document).off('keydown.kbShowroomComment').on('keydown.kbShowroomComment', '[data-comment-box]', function(event){
            if( event.keyCode == 13) {
                $(this).siblings("[data-comment-post]").trigger('click');
            }
        });
        $(document).off('click.kbShowroomCommentPost').on('click.kbShowroomCommentPost', '[data-comment-post]', function (e) {
            e.preventDefault();

            const input = $(this).prev("[data-comment-box]"),
                product_id = input.attr('data-comment-box');
            const text = input.val();

            const product = $(this).closest('.showroom-product');
            if (text == "") {
                return;
            } 


            $.ajax({
                method: "POST",
                url: _t.urls.commentPost,
                data: {
                    comment: text,
                    customer_id: _t.room.customer_id,
                    product_id: product_id
                },
                success: function (res) {
                    input.val("");
                    const comments = product.find('[data-showroom-comments]');
                    $(`
                    <div class="showroom-commment-box" data-comment="${res.comment.id}">
                        <div class="comment-profile">
                            ${showroom_data.customer_initials}
                        </div>
                        <div class="comment-info">
                            <div class="comment-text">
                                <div class="comment-author">${showroom_data.customer_name}</div>
                                ${res.comment.text}    
                            </div>
                            <a href="javascript:void(0);" data-comment-remove class="comment-box-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 4L4 12" stroke="#828282" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4 4L12 12" stroke="#828282" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </a>
                        </div>
                </div>`).insertAfter(comments);
                }
            })
        })

        // v7.11 fix: delegated binding — vote button is inside dynamically-
        // rendered showroom-product cards.
        $(document).off('click.kbShowroomVote').on('click.kbShowroomVote', '[data-showroom-product-vote]', function(){
            const $this = $(this),
            product = $this.closest('[data-showroom-product]'),
            product_votes_text = product.find('[data-showroom-product-votes]'),
            product_votes = product.find('.showroom-product-votes');

            const product_id = $this.attr('data-showroom-product-vote');

            $.ajax({
                method: "POST",
                url: _t.urls.dressVote,
                data: {
                    product_id: product_id,
                    customer_id: _t.room.customer_id
                },
                success: function (res) {
                    let votes_count = "1 vote";
                    if( res.count != 1) {
                        votes_count = `${res.count} votes`;
                    }
                    product_votes_text.text(votes_count);
                    if( res.vote) {
                        product_votes.addClass('active');
                    } else {
                        product_votes.removeClass('active');
                    }
                }
            });
        });

        $(document).on('click', '[data-comment-remove]', function () {
            const t = $(this),
                comment = t.closest('[data-comment]');


            $.ajax({
                url: _t.urls.commentRemove,
                method: "POST",
                data: {
                    comment_id: comment.attr('data-comment')
                },
                success: function (res) {
                    comment.remove();
                }
            })
        });
        $(document).on('click', '[data-assign-bridesmaid]', function () {
            const t = $(this),
                list = t.closest('[data-showroom-bridesmaids-list]'),
                product_id = list.attr('data-showroom-bridesmaids-list'),
                customer_id = t.attr('data-assign-bridesmaid');


            const product = $(this).closest(".showroom-product");
            let bridesmaids = product.data('bridesmaids');

            // Sets list as processing
            list.addClass('processing');

            // Assigns bridesmaid on backend
            $.ajax({
                url: _t.urls.dressAssign,
                method: "POST",
                data: {
                    customer_id,
                    product_id,
                    showroom_id: _t.room.room_id
                },
                success: function (res) {
                    bridesmaids.push(customer_id);
                    product.attr('data-bridesmaids', JSON.stringify(bridesmaids));

                    let list = [],
                        toBe = [];
                    for (let m of _t.room.members) {
                        if (bridesmaids.indexOf(m.id + "") >= 0) {
                            list.push(m)
                        } else {
                            toBe.push(m);
                        }
                    }

                    // Fills in assigned bridesmaids
                    // v7.13: render with hover-to-show X button so the bride
                    // can unassign a bridesmaid from a dress.
                    const bridesmaids_list = product.find('[data-showroom-dresses]').empty();
                    for (let m of list) {
                        const fullName = _t.generateFullNameFromMember(m);
                        $(`<div class="kb-bridesmaid-assigned" data-bridesmaid-assigned="${m.id}" title="${fullName}"><span class="bridesmaid-icon">${_t.generateInitialsFromMember(m)}</span><button type="button" class="kb-bridesmaid-unassign" data-bridesmaid-unassign="${m.id}" aria-label="Remove ${fullName}">×</button></div>`).appendTo(bridesmaids_list);
                    }

                    // Fills list of bridesmaids to assign again
                    const bList = product.find('[data-showroom-bridesmaids-list]');
                    bList.empty();
                    for (let m of toBe) {
                        $(`<a href="javascript:void(0)" data-assign-bridesmaid="${m.id}"><span class="bridesmaid-icon">${_t.generateInitialsFromMember(m)}</span> ${_t.generateFullNameFromMember(m)}</a>`).appendTo(bList);
                    }

                    // Stops processing
                    bList.removeClass('processing');
                }
            })
        });


        // v7.13: unassign a bridesmaid from a dress. The X button appears on
        // hover over an assigned bridesmaid. Clicking it removes them from
        // that dress's bridesmaid list. Calls the same dressAssign endpoint
        // with action: 'unassign' — backend should treat this as an unassign.
        // Falls back to local DOM-only update + warns to console if backend
        // doesn't recognize unassign action (so the UI still feels responsive
        // and we get diagnostic info).
        $(document).off('click.kbShowroomUnassign').on('click.kbShowroomUnassign', '[data-bridesmaid-unassign]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $btn = $(this);
            const $pill = $btn.closest('[data-bridesmaid-assigned]');
            const customer_id = $btn.attr('data-bridesmaid-unassign');
            const $product = $btn.closest('.showroom-product, [data-showroom-product]');
            const product_id = $product.attr('data-showroom-product') || $product.find('[data-showroom-bridesmaids-list]').attr('data-showroom-bridesmaids-list');

            if (!customer_id || !product_id) {
                console.warn('[showroom] unassign: missing customer_id or product_id', { customer_id, product_id });
                return;
            }

            // Optimistic UI: fade the pill out immediately
            $pill.css('opacity', 0.5);

            $.ajax({
                url: _t.urls.dressAssign,
                method: 'POST',
                data: {
                    customer_id: customer_id,
                    product_id: product_id,
                    showroom_id: _t.room.room_id,
                    action: 'unassign',
                    unassign: 1
                },
                success: function (res) {
                    console.log('[showroom] unassign response', res);
                    // Update product.data('bridesmaids') to reflect removal
                    let bridesmaids = $product.data('bridesmaids') || [];
                    bridesmaids = bridesmaids.filter(id => id != customer_id);
                    $product.attr('data-bridesmaids', JSON.stringify(bridesmaids));
                    $product.data('bridesmaids', bridesmaids);

                    // Move the bridesmaid back into the "assignable" list so
                    // they can be re-assigned later.
                    const member = (_t.room.members || []).find(m => m.id == customer_id);
                    if (member) {
                        const $assignList = $product.find('[data-showroom-bridesmaids-list]');
                        $assignList.append(`<a href="javascript:void(0)" data-assign-bridesmaid="${member.id}"><span class="bridesmaid-icon">${_t.generateInitialsFromMember(member)}</span> ${_t.generateFullNameFromMember(member)}</a>`);
                    }

                    // Remove the pill from the DOM
                    $pill.fadeOut(200, function () { $pill.remove(); });
                },
                error: function (jqXHR) {
                    console.error('[showroom] unassign failed', jqXHR.status, jqXHR.responseText);
                    // Even on error, remove from local UI — better UX than
                    // showing a stuck pill. State will reconcile on next page
                    // load if backend didn't accept the unassign.
                    $pill.fadeOut(200, function () { $pill.remove(); });
                }
            });
        });

        // v7.17: cancel-pending-invite handler REMOVED again. Direct API
        // testing against the backend confirmed every payload shape we tried
        // returned 400 Bad Request — the /api/showroom/update/invites endpoint
        // does not support a cancel/remove flag. Re-add when the backend has
        // a real cancel-invite endpoint we can call.

        // changing variant of dress in showroom
        $(document).on('change', '[data-showroom-change-product-color]', function(){
            const $this = $(this);
            const variant_id = $this.val();
            const showroom_product = $this.closest('[data-showroom-product]').addClass('processing');
            const showroom_product_id = showroom_product.attr('data-showroom-product');

            $.ajax({
                method: "POST",
                url: _t.urls.changeDressVariant,
                data: {
                    product_id: showroom_product_id,
                    variant_id
                },
                success: function (data) {
                    showroom_product.find('.showroom-dress-image').attr('src', data.image);
                    showroom_product.removeClass('processing');
                }
            })
        })
        // to change the add button based on color switch
        $('.js-colors-change').find('input').on('change', function () {
            const variant_id = _t.helpers.getCurrentVariantId();
            if (showroom_data.variants.indexOf(variant_id) > -1) {
                selectors.addToShowroomBtn.attr('data-showroom-added', true);
            } else {
                selectors.addToShowroomBtn.removeAttr('data-showroom-added');
            }

        });

        selectors.closeModalBtn.on('click', function () {
            $(this).parent().plainModal('close');
        });

        // v7.11 fix: delegated binding — the bridesmaid Remove link is inside
        // the bridal party list which can re-render after invites are accepted.
        $(document).off('click.kbShowroomMemberRemove').on('click.kbShowroomMemberRemove', '[data-delete-member]', function () {
            const $bridesmaid = $(this).parent();
            const $bridesmaids = $bridesmaid.parent();
            const bridesmaidId = $(this).attr('data-delete-member');
            const bridesmaidName = $bridesmaid.find('.bridesmaid-name').text();

            if (confirm(`Are you sure you want to remove ${bridesmaidName} from your Showroom?`)) {
                $bridesmaid.addClass('being-removed');
                _t.removeMemberFromShowroom(bridesmaidId)
                    .then(() => {
                        $bridesmaid.remove();

                        const remainingBridesmaids = $bridesmaids.find('.bridesmaid').length;
                        if (remainingBridesmaids < 1) {
                            $bridesmaids.append($('<div class="pending-invitation">No members on your Showroom yet!</div>'));
                        }
                    });
            }
        });

        if (window.location.hash == "#showroom" || window.location.search.indexOf("?showroom") || window.location.search.indexOf('?Showroom')) {
            // _t.openShowroom();
        }
        if( window.showroom.isShowroomOpen ) {
            _t.openShowroom();
        }
    },

    showInvitationModal: function () {
        // Let's not show the invitation on the post-registration page
        // This will avoid bugs since the data must first go to the Showroom backend
        if (document.location.search.includes('view=after-registration')) {
            return;
        }

        const _t = this;
        const pendingInvite = sessionStorage.getItem('showroom_invite_pending');
        if (pendingInvite) {
            const owner_id = sessionStorage.getItem('showroom_invite_owner');
            if (_t.room.customer_id == owner_id) {
                return;
            }
            const selectors = _t.selectors;
            selectors.invitationInitials.text(sessionStorage.getItem('showroom_invite_initials'));
            selectors.invitationFirstName.text(sessionStorage.getItem('showroom_invite_first_name'));

            _t.selectors.showroomInvitationModal.plainModal('open');

        }
    },
    processShowroomInvites: function () {
        const _t = this;
        return new Promise((res, rej) => {
            $.ajax({
                method: "POST",
                url: _t.urls.processShowroomInvite,
                data: {
                    customer_id: _t.room.customer_id,
                    link: sessionStorage.getItem('showroom_invite_pending'),
                    customer_email: _t.room.customer_email
                },
                success: function (data) {
                    res(data);
                }
            })
            sessionStorage.removeItem('showroom_invite_pending');
        });
    },
    removeMemberFromShowroom: function (memberId) {
        return new Promise((resolve, reject) => {
            if (!this.isShowroomOwner) return reject('Only the Showroom owner can delete members');

            $.ajax({
                method: 'POST',
                url: this.urls.removeShowroomMember,
                data: {
                    member_id: memberId,
                    customer_id: this.room.customer_id,
                    showroom_id: this.room.room_id,
                },
                success: function () {
                    resolve();
                },
            });
        });
    },
    setShowroomCustomizations: function() {
        if (!window.showroom_customizations) return;

        window.showroom_customizations.roles.forEach(role => {
            $("<option></option>").text(role).prop('value', role).appendTo($("#roles"));
            $("<option></option>").text(role).prop('value', role).appendTo($("#edit_roles"));
        });
        window.showroom_customizations.colors.forEach(color => {
            $("<option></option>").text(color).prop('value', color).appendTo($("#colors"));
            $("<option></option>").text(color).prop('value', color).appendTo($("#edit_colors"))
        });
        window.showroom_customizations.budget.forEach(budget => {
            $("<option></option>").text(budget).prop('value', budget).appendTo($("#budget"));
            $("<option></option>").text(budget).prop('value', budget).appendTo($("#edit_budget"))
        });
        window.showroom_customizations.mix_match.forEach(mm => {
            $("<option></option>").text(mm).prop('value', mm).appendTo($("#mixmatch"));
            $("<option></option>").text(mm).prop('value', mm).appendTo($("#edit_mixmatch"))
        });

        ['#roles', '#edit_roles', '#colors', '#edit_colors', '#budget', '#edit_budget', '#mixmatch', '#edit_mixmatch'].forEach((inputSelector) => {
            $(inputSelector).val($(inputSelector).attr('data-value') || '');
        });
    },
    getInitData: function () {
        const _t = this;
        if( window.showroom_data == undefined ){
            return;
        }
        _t.room.room_id = _t.selectors.metaShowroomRoomId.attr('content');
        _t.room.customer_id = _t.selectors.metaShowroomCustomerId.attr('content');
        _t.room.customer_email = _t.selectors.metaShowroomCustomerEmail.attr('content');
        _t.room.data = $.parseJSON(window.showroom_data.room_data);
        _t.room.members = $.parseJSON(window.showroom_data.members);
        if (_t.room.data) {
            _t.room.data = _t.room.data.showroom;
        }
        window.showroom_data.memberships = $.parseJSON(window.showroom_data.memberships);
    },
    /**
     * v7.12: Persists the latest showroom state (variants + products) to
     * sessionStorage after every add/remove API call. Subsequent page loads
     * (collection page, PDP, etc.) read this BEFORE reading window.showroom_data
     * — which is rendered server-side from the Liquid metafield and can be
     * cache-stale for several minutes after a delete. This is the fix for the
     * "I deleted Brittany but the collection card still says Remove from
     * Showroom" bug. Stale-bust window: 30 minutes.
     */
    /**
     * v7.17: Lightweight toast notification. Used by add-to-showroom and
     * remove-from-showroom flows to give the customer immediate feedback
     * ("Added to Madeline's Showroom"). Self-contained — no third-party
     * dependency. Multiple toasts stack vertically. Each one auto-dismisses
     * after 2.5s.
     */
    showToast: function (message, opts) {
        // v8.9.18.8: moved to top-center + pink brand accent + bigger so it's actually noticeable
        opts = opts || {};
        try {
            var containerId = 'kb-toast-container';
            var container = document.getElementById(containerId);
            if (!container) {
                container = document.createElement('div');
                container.id = containerId;
                container.setAttribute('aria-live', 'polite');
                container.setAttribute('aria-atomic', 'true');
                container.style.cssText = 'position:fixed;top:24px;left:50%;transform:translateX(-50%);z-index:99999;display:flex;flex-direction:column;gap:10px;pointer-events:none;width:auto;max-width:92vw;';
                document.body.appendChild(container);
            }
            var toast = document.createElement('div');
            toast.className = 'kb-toast';
            toast.style.cssText = 'background:#fb758d;color:#fff;padding:16px 24px;border-radius:999px;font-size:15px;font-weight:600;letter-spacing:0.2px;font-family:"Open Sans",sans-serif;line-height:1.2;box-shadow:0 8px 24px rgba(251,117,141,0.35),0 2px 6px rgba(0,0,0,0.12);min-width:240px;max-width:480px;text-align:center;opacity:0;transform:translateY(-12px);transition:opacity 0.22s ease,transform 0.22s ease;pointer-events:auto;';
            var checkIcon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:10px;flex-shrink:0;"><polyline points="20 6 9 17 4 12"/></svg>';
            toast.innerHTML = '<span style="display:inline-flex;align-items:center;justify-content:center;">' + checkIcon + '<span>' + (message || '') + '</span></span>';
            container.appendChild(toast);
            requestAnimationFrame(function () {
                toast.style.opacity = '1';
                toast.style.transform = 'translateY(0)';
            });
            setTimeout(function () {
                toast.style.opacity = '0';
                toast.style.transform = 'translateY(-12px)';
                setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 240);
            }, opts.duration || 3500);
        } catch (e) {
            console.warn('[showroom] showToast failed', e);
        }
    },

    persistShowroomState: function (data) {
        // v7.13 fix: was using sessionStorage which is PER-TAB. Customers
        // testing across multiple tabs (delete in tab A, view PDP in tab B)
        // never saw fresh state because each tab has its own sessionStorage.
        // Switched to localStorage which is per-ORIGIN and shared across all
        // tabs of the same domain. Fresh state now propagates everywhere.
        try {
            var payload = JSON.stringify({
                products: (data && data.product_ids != null) ? data.product_ids : (window.showroom_data && window.showroom_data.products) || '',
                variants: (data && data.variant_ids != null) ? data.variant_ids : (window.showroom_data && window.showroom_data.variants) || '',
                customer_id: (window.showroom_data && window.showroom_data.customer_id) || null,
                ts: Date.now()
            });
            localStorage.setItem('kb_showroom_state', payload);
            // Keep sessionStorage write too for backward compat with any v7.12
            // code paths that might read from it.
            try { sessionStorage.setItem('kb_showroom_state', payload); } catch (e) {}
            // Overwrite in-memory copy so concurrent code on the same page
            // sees the fresh state immediately.
            if (window.showroom_data) {
                if (data && data.product_ids != null) window.showroom_data.products = data.product_ids;
                if (data && data.variant_ids != null) window.showroom_data.variants = data.variant_ids;
            }
        } catch (e) { console.warn('[showroom] persist state failed', e); }
    },

    /**
     * v7.11: Walks every [data-showroom-add] / [data-showroom-add-2] element
     * in the DOM and reconciles its `data-showroom-added` attribute against
     * the live state. Run on page load and after every add/remove.
     * v7.12 update: prefers sessionStorage state (fresher than the
     * Liquid-rendered window.showroom_data) when available.
     */
    syncShowroomCardStates: function () {
        if (!window.showroom_data) return;
        // v7.13: Read from localStorage (cross-tab) first, sessionStorage second
        // (same-tab fallback for v7.12), Liquid metafield third (server-rendered,
        // can be cache-stale). Use the freshest source available.
        var products, variants;
        var customerId = (window.showroom_data && window.showroom_data.customer_id) || null;
        try {
            var saved = JSON.parse(localStorage.getItem('kb_showroom_state') || sessionStorage.getItem('kb_showroom_state') || 'null');
            // Validate: same customer, recent (<60 min)
            if (saved && saved.ts &&
                (Date.now() - saved.ts) < 60 * 60 * 1000 &&
                (!saved.customer_id || saved.customer_id == customerId)) {
                products = (saved.products || '').toString().split(',').filter(Boolean);
                variants = (saved.variants || '').toString().split(',').filter(Boolean);
                window.showroom_data.products = saved.products || '';
                window.showroom_data.variants = saved.variants || '';
            }
        } catch (e) { /* fall through to liquid-source */ }
        if (!products) {
            variants = (window.showroom_data.variants || '').toString().split(',').filter(Boolean);
            products = (window.showroom_data.products || '').toString().split(',').filter(Boolean);
        }
        // v8.2.2: Buttons + toasts use the literal word "Showroom", never
        // the actual room name. Per Jimmy: "Add to Madeline" / "Remove from
        // Madeline" was confusing — bridesmaids interpreted "Madeline" as
        // a person, not a showroom. Generic "Showroom" is universally clear.
        var roomName = 'Showroom';
        var shortName = 'Showroom';

        $('[data-showroom-add]').each(function () {
            var $btn = $(this);
            var variantId = $btn.attr('data-showroom-variant');
            var productId = ($btn.data('showroom-add') || '').toString();
            var isAdded = (variantId && variants.indexOf(variantId.toString()) > -1) ||
                          (productId && products.indexOf(productId) > -1);
            if (isAdded) {
                $btn.attr('data-showroom-added', 'true');
            } else {
                $btn.removeAttr('data-showroom-added');
            }
        });

        // v7.14 fix: ALWAYS rewrite the button HTML to match desired state.
        // Previous version only rewrote HTML when the SVG/heart was missing,
        // which meant a server-rendered "Remove from Showroom" button with the
        // SVG already in place was never updated to "Add to Showroom" — so
        // customers saw stale text and clicking ran the (correct) Add path
        // because the data attribute had been corrected. Confusing UX.
        // v8.2.2: Use the same hanger SVG for BOTH add and remove states.
        // Previously remove used a trash icon and add used a heart icon —
        // when you clicked "Remove from Showroom" the icon flipped from
        // hanger → heart, which broke the brand consistency. Now hanger
        // for both, and "Showroom" text instead of the room name.
        var hangerSvg = '<svg class="kb-hanger-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="6.5" r="1.5"/><path d="M12 8 V11 L3 17 H21 L12 11"/></svg>';

        $('[data-showroom-add-2]').each(function () {
            var $btn = $(this);
            var productId = ($btn.data('showroom-add-2') || '').toString();
            var variantId = $btn.attr('data-showroom-variant');
            var isAdded = (variantId && variants.indexOf(variantId.toString()) > -1) ||
                          (productId && products.indexOf(productId) > -1);
            if (isAdded) {
                $btn.attr('data-showroom-added', 'true');
                $btn.html(hangerSvg + ' Remove from Showroom');
            } else {
                $btn.removeAttr('data-showroom-added');
                $btn.html(hangerSvg + ' Add to Showroom');
            }
        });

        // v7.14 fix → REWRITTEN v8.1.2: previously called $pdpBtn.text(removeText)
        // which wipes the entire button innerHTML — destroying the SVG icon and
        // replacing it with raw "Remove from Showroom" text. Combined with the
        // pink [data-current-state="added"] background, this produced a pink
        // text-only oval at top-left of the PDP image instead of the icon-only
        // hanger. v8.1 made the PDP button icon-only so we no longer want any
        // visible text — only update aria-label/title for accessibility, and
        // flip data-current-state so the CSS-driven pink "added" background
        // applies correctly. The SVG inside the button is preserved.
        var $pdpBtn = $('#pdp-cta-showroom-add');
        if ($pdpBtn.length) {
            var pdpVariantId = $pdpBtn.attr('data-current-variant');
            var pdpProductId = $pdpBtn.attr('data-product-id');
            var isAddedPdp = (pdpVariantId && variants.indexOf(pdpVariantId.toString()) > -1) ||
                             (pdpProductId && products.indexOf(pdpProductId.toString()) > -1);
            var addText = $pdpBtn.attr('data-text-add') || 'Add to Showroom';
            var removeText = $pdpBtn.attr('data-text-remove') || 'Remove from Showroom';
            var stateLabel = isAddedPdp ? removeText : addText;
            $pdpBtn.attr('aria-label', stateLabel);
            $pdpBtn.attr('title', stateLabel);
            $pdpBtn.attr('data-current-state', isAddedPdp ? 'added' : 'not-added');
            $pdpBtn.removeAttr('disabled');
        }
    },

    init: function () {
        // This prevents the Showroom init from happening twice and causing bugs
        if (window.showroom.hasInitialized) return;
        window.showroom.hasInitialized = true;

        // v8.9.20.4: Close X for invite modal. Direct binding (not document delegation)
        // because newModal lib's .new-modal-content stopPropagation eats document-level events.
        try {
            $('[data-kb-modal-close]').off('click.kbModalClose').on('click.kbModalClose', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var $modal = $(this).closest('.new-modal');
                if ($modal.length) {
                    if ($modal.newModal) { $modal.newModal('close'); }
                    else { $modal.fadeOut(200); $('html,body').removeClass('new-modal-fixed'); }
                }
            });
        } catch (err) { console.warn('[showroom] close X bind failed', err); }

        const _t = this;

        this.cacheSelectors();
        this.getInitData();
        this.setShowroomCustomizations();

        this.setModalEvents();
        if (this.room.customer_id) {
            this.setEvents();
            this.setMembershipEvents();
            // v7.11: sync card states on init in case server-rendered HTML is
            // stale (e.g. after a delete where the metafield-cached Liquid
            // hasn't refreshed yet)
            try { _t.syncShowroomCardStates(); } catch (e) { console.warn('[showroom] state sync failed', e); }
            // v8.9.19.7: extracted X-decorator into reusable method.
            // Run initially + observe DOM mutations so the X buttons survive
            // chunked product re-renders (which previously wiped them).
            try { _t.decorateUnassignButtons(); } catch (e) { console.warn('[showroom] decorate failed', e); }
            try { _t.installUnassignObserver(); } catch (e) { console.warn('[showroom] unassign observer failed', e); }
            // v7.13: cross-tab live update. When another tab writes new state
            // to localStorage (e.g. customer deleted Brittany on the dress
            // planner), this tab re-syncs immediately. No refresh needed.
            try {
                window.addEventListener('storage', function (e) {
                    if (e.key === 'kb_showroom_state') {
                        try { _t.syncShowroomCardStates(); } catch (err) { console.warn('[showroom] cross-tab sync failed', err); }
                    }
                });
            } catch (e) { /* older browser, ignore */ }
        } else {
            _t.selectors.loginShowroomBtn.on('click', function (e) {
                e.preventDefault();
                localStorage.setItem('after-registration', $(this).attr('href'));
                location.href = $(this).attr('href');
            });
        }

        if (window.location.hash.includes('#showroom-') && !window.location.hash.includes(this.invitedShowroomPrefix)) {
            const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            const hashShowroom = window.location.hash.split("-");
            const showroom_id = hashShowroom[1];
            const invitedGuest = hashShowroom.pop();
            
            const _t = this;

            const showroom_in_storage = sessionStorage.getItem("showroom_invite_pending");

            const processInvitation = function () {
                const invitedBridesMaids = atob(invitedGuest)
                _t.room.customer_email = invitedBridesMaids
                
                if(regexEmail.test(invitedBridesMaids)){
                    showroom.showInvitationModal();
                }
            };

            if (showroom_in_storage != showroom_id) {
                $.ajax({
                    method: "GET",
                    url: _t.urls.getInvitationData,
                    data: {
                        showroom_link: showroom_id
                    },
                    success: function (data) {
                        sessionStorage.setItem('showroom_invite_pending', showroom_id);
                        sessionStorage.setItem('showroom_invite_room_id', data.showroom_id);
                        sessionStorage.setItem('showroom_invite_first_name', data.first_name);
                        sessionStorage.setItem('showroom_invite_last_name', data.last_name);
                        sessionStorage.setItem('showroom_invite_initials', data.initials);
                        sessionStorage.setItem('showroom_invite_owner', data.owner_id);

                        processInvitation();
                    }
                });
            } else {
                processInvitation();
            }
        }

        let id = $('a.showroom-btn').data('showroom-membership-open');

        
        if (window.location.hash.includes(this.invitedShowroomPrefix)) {
            $("#showroom-page").hide().siblings().hide();
            if(id == undefined){
                var hash = window.location.hash.split("-")
                id = hash.pop()
            }
            $(`#showroom-page-${id}`).show();

            const interval_id = `scomments_${id}`;
            _t.loadComments(id);
            if (!window[interval_id]) {
                // v8.9.18.6: dial 1s -> 5s on membership comment polling too
                window[interval_id] = setInterval(function () {
                    _t.loadComments(id);
                }, 5000);
            } else {
                clearInterval(window[interval_id]);
                window[interval_id] = false;
            }
        }

        if (window.showroom_customer_logged_in) {
            showroom.showInvitationModal();
        }
      	
        // Loads Helppier tutorial based on query string
      	const queryString = window.location.search;
      	const urlParams = new URLSearchParams(queryString);
        
        if (urlParams.get('HPermalink')) {
            this.showTutorial(urlParams.get('HPermalink'));
        }
    },
    showTutorial (tutorialId) {
        // Shows loader
        $('#helppierLoader').show();

        // Waits until load is complete
        const checkForHelppierLoad = setInterval(() => {
            if ($('.helppierIframe').length > 0) {
                $('#helppierLoader').hide();
                clearInterval(checkForHelppierLoad)
            }
        }, 100);

        // This is what will load Helppier
        helppierInit({ silent: true }, (err, init) => {
            if (err) {
                console.error('Error loading helppier', err);
            } else {
                init.startPlay(tutorialId);
            }
        });
    },

    // Preloads data required for the Showroom, then jumps into the init sequence
    preload () {
        // Sets correct Showroom ID and ownership type
        if (window.location.hash.indexOf('#showroom-page-') >= 0) {
            this.invitedShowroomId = window.location.hash.split('-').pop();
        } else {
            this.isShowroomOwner = this.isShowroomOpen;
        }

        // Does loading of products + inits
        this.loadProducts()
            .then(() => {
                this.init();
                // v8.9.19.7: install observer right after products render so it
                // catches any subsequent re-renders (chunked refreshes, etc.)
                try { this.decorateUnassignButtons(); } catch (e) {}
                try { this.installUnassignObserver(); } catch (e) {}
            });
    },

    // Showroom page - loads Showroom data from custom endpoint and displays here
    loadProducts () {
        return new Promise((resolve, reject) => {
            // Short-circuit in case we're not in a valid Showroom page
            if (!(this.isShowroomOpen || this.invitedShowroomId)) {
                return resolve();
            }

            // Defines active Showroom page
            const showroomPage = this.isShowroomOwner
                ? $('#showroom-page')
                : $(`#showroom-page-${this.invitedShowroomId}`);
            
            // Loads JSON data from Showroom and parses it
            const showroomDataRaw = showroomPage.find('.showroom-products-data').text();
            if (showroomDataRaw.length === 0 || showroomDataRaw === 'null') return resolve();
            const showroomProducts = JSON.parse(showroomDataRaw);
            
            // Splits the whole list of products in chunks of N products
            const productsPerChunk = 20;
            const chunkCount = Math.ceil(showroomProducts.length / productsPerChunk);
            const chunks = [];
            for (let iChunk = 0; iChunk < chunkCount; iChunk++) {
                const iChunkStart = iChunk * productsPerChunk;
                const chunk = [];

                // Adds each product for the current chunk, makes sure product exists
                // Necessary when total products isn't exactly divisible by 20
                for (let iProduct = iChunkStart; iProduct < iChunkStart + productsPerChunk; iProduct++) {
                    const product = showroomProducts[iProduct];
                    if (product) {
                        chunk.push(product);
                    }
                }

                // Safeguard to prevent empty requests
                if (chunk.length > 0) {
                    chunks.push({ start: iChunkStart, length: chunk.length });
                }
            }

            // Sets correct output container
            const output = showroomPage.find('.showroom-products');

            // Sends requests and wait for them to finish
            Promise.all(
                chunks.map(chunk => this.loadProductsChunk(chunk))
            ).then((htmlChunks) => {
                output.html(htmlChunks.join(''));
                // v7.15 fix: detect "stale metafield with no actual products"
                // case. If the rendered HTML is empty (no .showroom-product
                // children, or only whitespace), the metafield had IDs that
                // don't resolve to real products anymore. Hide the full wrapper
                // and show the empty wrapper so the bride sees a CTA instead
                // of a blank box. The Liquid `{% if products == blank %}`
                // check happens before this and only catches truly-empty
                // metafields, not stale-ID cases.
                try {
                    var renderedCount = output.find('.showroom-product, [data-showroom-product]').length;
                    if (renderedCount === 0) {
                        showroomPage.find('.showroom-full-wrapper').hide();
                        showroomPage.find('.showroom-empty-wrapper').show();
                    }
                } catch (e) { console.warn('[showroom] empty-state fallback failed', e); }
                resolve();
            })
        });
    },

    // Loads a chunk of products
    loadProductsChunk (chunk) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/pages/welcome-to-kennedy-blue?view=showroom_chunk&room=${this.isShowroomOwner ? 'customer' : this.invitedShowroomId}&start=${chunk.start}&length=${chunk.length}&v=${SHOPIFY_CUSTOMER_ID}_${Date.now()}_${Math.random()}`,
                success: function (data) {
                    resolve(data);
                },
            });
        });
    },
};
$(document).ready(function () {
    showroom.preload();

    $('#new-showroom-modal')
        .on('plainmodalbeforeclose', function(event) {
            if ( !window.showroom.showroomUpdated ) {
                event.preventDefault();
                console.log('Preventing modal close');
                return false; 
            }
            window.showroom.showroomUpdated = false; // so we change the flag after updating. 
        });
});